/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { useLocation } from '@jira/navigation-apps__routing-hooks/src/useLocation.tsx';
import { useRoute } from '@jira/navigation-apps__routing-hooks/src/useRoute.tsx';
import { findItemAndStack } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-connect/src/common/utils/find-item-stack/index.tsx';
import { useConnectApps } from '../connect-apps/index.tsx';

export const useIsConnectAppActive = (): {
	isActive: boolean;
	loading: boolean;
	error: // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| Record<string, any>
		| Error // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| (Record<string, any> & Error) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| (Error & Record<string, any>)
		| null;
} => {
	const location = useLocation();
	const route = useRoute();
	const { data: connectApps, error, loading } = useConnectApps();

	const isActive = useMemo(
		() => Boolean(findItemAndStack(connectApps, route.name, location)?.selected),
		[connectApps, location, route.name],
	);

	return { isActive, loading, error };
};
